module.exports = __webpack_public_path__ + "img/experience.2f458633.png";